export const isLocaleSameMonthAndYear = (a: Date, b: Date, timeZone: string) => {
  return (
    a.toLocaleString("fr-FR", { year: "numeric", month: "numeric", timeZone }) ===
    b.toLocaleString("fr-FR", { year: "numeric", month: "numeric", timeZone })
  );
};
